import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaUserCircle, FaBars, FaTimes, FaMoon, FaSun } from 'react-icons/fa';
import { ENTITIES } from '../constants/entities';

function Navbar({ isAdmin, admin, onLogout }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [entitiesDropdownOpen, setEntitiesDropdownOpen] = useState(false);

  // Load dark mode preference from localStorage
  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode') === 'true';
    setDarkMode(savedDarkMode);
    if (savedDarkMode) {
      document.body.classList.add('dark-mode');
    }
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (entitiesDropdownOpen && !event.target.closest('.dropdown')) {
        setEntitiesDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [entitiesDropdownOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem('darkMode', newDarkMode);
    if (newDarkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-2" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }}>
      <div className="container-fluid">
        {/* Logo */}
        <Link className="navbar-brand" to="/dashboard">
          <img
            src="/solio-logo.png"
            alt="Solio"
            height="40"
          />
        </Link>

        {/* Navigation - Desktop */}
        <div className="d-none d-lg-flex align-items-center">
          {isAdmin && (
            <div className="dropdown me-3">
              <span
                className="nav-link dropdown-toggle"
                role="button"
                onClick={() => setEntitiesDropdownOpen(!entitiesDropdownOpen)}
                style={{ cursor: 'pointer', color: '#000' }}
              >
                Entités
              </span>
              {entitiesDropdownOpen && (
                <ul className="dropdown-menu show">
                  {ENTITIES.map((entity) => (
                    <li key={entity}>
                      <Link
                        className="dropdown-item"
                        to={`/filiale/${entity}`}
                        onClick={() => setEntitiesDropdownOpen(false)}
                      >
                        {entity}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
          <Link className="btn btn-sm btn-outline-primary me-2" to="/create-job">+ Offre</Link>

          {/* User info */}
          <div className="d-flex align-items-center me-2">
            <FaUserCircle size={20} className="me-1" style={{ color: '#000' }} />
            <span style={{fontSize: '0.85rem', color: '#000'}}>{admin?.full_name}</span>
          </div>

          <button
            className="btn btn-link p-1 me-2"
            onClick={toggleDarkMode}
            title={darkMode ? "Mode clair" : "Mode sombre"}
            style={{ color: '#000' }}
          >
            {darkMode ? <FaSun size={18} /> : <FaMoon size={18} />}
          </button>
          <button onClick={onLogout} className="btn btn-danger btn-sm">
            Déconnexion
          </button>
        </div>

        {/* Mobile toggle */}
        <button
          className="navbar-toggler d-lg-none"
          onClick={toggleMobileMenu}
        >
          {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="d-lg-none position-absolute top-100 end-0 bg-white shadow-lg p-3" style={{ zIndex: 1000, width: '250px' }}>
            <div className="mb-2">
              <FaUserCircle size={20} className="me-2" />
              <span>{admin?.full_name}</span>
            </div>
            {isAdmin && ENTITIES.map((entity) => (
              <Link
                key={entity}
                className="d-block py-1 text-decoration-none"
                to={`/filiale/${entity}`}
                onClick={toggleMobileMenu}
              >
                {entity}
              </Link>
            ))}
            <Link
              className="d-block py-1 text-decoration-none"
              to="/create-job"
              onClick={toggleMobileMenu}
            >
              + Offre
            </Link>
            <button
              onClick={() => {
                onLogout();
                toggleMobileMenu();
              }}
              className="btn btn-danger btn-sm w-100 mt-2"
            >
              Déconnexion
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
